import { render, staticRenderFns } from "./tabTimer.vue?vue&type=template&id=72f1c21c&scoped=true&"
import script from "./tabTimer.vue?vue&type=script&lang=js&"
export * from "./tabTimer.vue?vue&type=script&lang=js&"
import style0 from "./tabTimer.vue?vue&type=style&index=0&id=72f1c21c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f1c21c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VIcon,VSubheader,VTab,VTabItem,VTabs,VTabsItems,VTabsSlider,VTextField})
